import type { ToolResult } from "@/types/tools";

export type DecodedJwt = {
  header: unknown;
  payload: unknown;
  signature: string;
};

function decodeBase64UrlJson(segment: string): unknown {
  const normalized = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
  const binary =
    typeof atob === "function"
      ? atob(padded)
      : Buffer.from(padded, "base64").toString("binary");
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  const text = new TextDecoder("utf-8", { fatal: true }).decode(bytes);

  return JSON.parse(text);
}

export function decodeJwt(token: string): ToolResult<DecodedJwt> {
  const parts = token.trim().split(".");

  if (parts.length !== 3 || parts.some((part) => part.length === 0)) {
    return {
      ok: false,
      error: "JWTs must have header, payload, and signature segments.",
    };
  }

  try {
    return {
      ok: true,
      value: {
        header: decodeBase64UrlJson(parts[0]),
        payload: decodeBase64UrlJson(parts[1]),
        signature: parts[2],
      },
    };
  } catch {
    return {
      ok: false,
      error: "Token header or payload could not be decoded as JSON.",
    };
  }
}
